// Quién manda sobre el branding que se ve. Lógica pura; el estado lo trae `aplicar.ts`.

import { SLUG_ATLAS } from './catalogo';

export interface EntradaDeResolucion {
  /** ¿Hay sesión? Con sesión la empresa decide; sin sesión sólo queda lo recordado. */
  conSesion: boolean;
  /** `?branding=<slug>`, pegado a la pestaña (sessionStorage). Gana siempre: es la previsualización y el link del cliente. */
  forzado?: string | null;
  /** `company_profiles.branding` de la empresa de la sesión. `null` = Atlas. */
  deEmpresa?: string | null;
  /** El último branding aplicado en este dispositivo (localStorage). Sólo cuenta sin sesión. */
  recordado?: string | null;
}

const oNulo = (s: string | null | undefined): string | null => (s && s.trim() ? s.trim() : null);

export function resolverSlug({ conSesion, forzado, deEmpresa, recordado }: EntradaDeResolucion): string {
  const forzadoLimpio = oNulo(forzado);
  if (forzadoLimpio) return forzadoLimpio;
  if (conSesion) return oNulo(deEmpresa) ?? SLUG_ATLAS;
  return oNulo(recordado) ?? SLUG_ATLAS;
}

/** El slug de `?branding=` en `location.search`, normalizado; `null` si no viene. */
export function slugForzadoDesdeUrl(search: string): string | null {
  const valor = new URLSearchParams(search).get('branding');
  return oNulo(valor?.toLowerCase() ?? null);
}
